import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type {
  IbhBearingPartsLightParams,
  IbhIcnPartsRequestDto,
  IbhPartsLifetimeResponseDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import * as Sentry from '@sentry/nextjs';

export const fetchPartsIcnLifetime = async (
  query: IbhBearingPartsLightParams,
  data: IbhIcnPartsRequestDto
): Promise<IbhPartsLifetimeResponseDto> => {
  try {
    ibhApiService.abortRequest('bearingPartsIcnLifetime');
    const response = await ibhApiService.bearingPartsIcnLifetime(
      query,
      { ...data },
      { cancelToken: 'bearingPartsIcnLifetime' }
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      contexts: {
        request: {
          query,
          data: { ...data },
        },
      },
      tags: {
        api_call: 'bearingPartsIcnLifetime',
      },
      level: 'error',
    });
    throw new Error(`Cannot fetch parts ICN lifetime for given data: ${JSON.stringify(data)}`);
  }
};
